import { Card, CardContent } from "@shared/components/ui/card";

import { TrendingUp } from "lucide-react";

const StatCard = ({
  title,
  value,
  icon: Icon,
  trend,
  color = "blue",
  iconBgColor,
  iconColor,
}) => {
  const colorClasses = {
    blue: "text-blue-600 bg-blue-50 dark:bg-blue-950",
    green: "text-green-600 bg-green-50 dark:bg-green-950",
    orange: "text-orange-600 bg-orange-50 dark:bg-orange-950",
    red: "text-red-600 bg-red-50 dark:bg-red-950",
    purple: "text-purple-600 bg-purple-50 dark:bg-purple-950",
  };

  // Handle trend as either a string or an object with value and isPositive
  const trendValue = typeof trend === "string" ? trend : trend?.value;
  const trendIsPositive = typeof trend === "object" ? trend?.isPositive : true;

  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="text-2xl font-bold">{value}</p>
            {trendValue && (
              <p
                className={`text-xs flex items-center mt-1 ${
                  trendIsPositive ? "text-green-600" : "text-red-600"
                }`}
              >
                <TrendingUp
                  className={`h-3 w-3 mr-1 ${!trendIsPositive && "rotate-180"}`}
                />
                {trendValue}
              </p>
            )}
          </div>
          <div
            className={iconBgColor || `p-3 rounded-full ${colorClasses[color]}`}
          >
            <Icon className={`h-6 w-6 ${iconColor || ""}`} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StatCard;
